import React, { useEffect, useState } from 'react';
import {  useParams } from 'react-router-dom';
import { Carousel, Modal } from 'react-bootstrap';
import axios from 'axios';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000, // Ensures the modal is above other content
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '5px',
    position: 'relative',
    maxWidth: '600px',
    width: '100%',
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  closeButton: {
    cursor: 'pointer',
    border: 'none',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    margin: '0',
    background: 'transparent',
  },
};
const GujraatStateHeadPending = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [showCarousel, setShowCarousel] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage('');
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(`https://amaapi.outdoorooh.com/api/gujaratcampaign-projects/${id}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setUser(response.data.data);
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUser();
  }, [id]);

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setShowCarousel(true);
  };

  const handleCloseCarousel = () => setShowCarousel(false);

  if (!user) return <div>Loading...</div>;

  const handleApproval = async (status, additionalParam = '') => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      alert('User data not found in localStorage!');
      return;
    }
    const parsedUserData = JSON.parse(userData);
    const nodleAgencyApprovalId = parsedUserData?.id || '';

    const apiUrl = `https://amaapi.outdoorooh.com/api/gujaratcampaign-site-asm-approval`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          project_id: id,
          asm_approver_id: nodleAgencyApprovalId,
          asm_status: status,
          reason: additionalParam || '',
        }),
      });

      if (response.ok) {
        const data = await response.json();
        alert(`Action successful: ${status}`);
        console.log(data);
      } else {
        alert('Action failed');
        console.error('Error:', response.statusText);
      }
    } catch (error) {
      alert('An error occurred');
      console.error('Error:', error);
    }
  };

  const openRejectPopup = () => {
    setIsPopupOpen(true);
  };

  const closeRejectPopup = () => {
    setIsPopupOpen(false);
  };

  const handleReject = () => {
    if (!selectedReason) {
      alert('Please select a reason before proceeding!');
      return;
    }
    handleApproval('Rejected', selectedReason);
    closeRejectPopup();
  };

  // Recursive helper for Next


  return (
    <>
     

      <div style={{ background: '#fff', borderRadius: '10px' }}>
        <div className="p-4">
          <div className="d-flex flex justify-content-between">
            <div>
              <h4 className="d-flex">
                <span>Site Name :</span> {user.site_name}, &nbsp; &nbsp;
                <h4>
                  <span>Code :</span> {user.code}
                </h4>
              </h4>
            </div>
          </div>
          <table className="table ">
            <tbody>
              <tr>
                <td width="200">
                  <h6>Zone </h6>
                </td>
                <td>: {user.zone}</td>

                <td width="200">
                  <h6>State </h6>
                </td>
                <td>: {user.state}</td>
                <td width="200">
                  <h6>Area </h6>
                </td>
                <td>: {user.area}</td>
              </tr>

              <tr>
                <td width="200">
                  <h6>Start Date </h6>
                </td>
                <td>: {user.start_date}</td>

                <td width="200">
                  <h6>End Date </h6>
                </td>
                <td>: {user.end_date}</td>

                <td width="200">
                  <h6>Vendor Name </h6>
                </td>
                <td>: {user.vendor_name}</td>
              </tr>

              <tr>
                <td width="200">
                  <h6>Height </h6>
                </td>
                <td>: {user.length}</td>
                <td width="200">
                  <h6>Width </h6>
                </td>
                <td>: {user.width}</td>
                <td width="200">
                  <h6>Unit </h6>
                </td>
                <td>: {user.unit}</td>
              </tr>

              <tr>
                <td width="200">
                  <h6>Total </h6>
                </td>
                <td>: {user.total}</td>
                <td width="200">
                  <h6>Lat </h6>
                </td>
                <td>: {user.lat}</td>
                <td width="200">
                  <h6>Long </h6>
                </td>
                <td>: {user.long}</td>
              </tr>
                   <tr>
                <td width="200">
                  <h6>Remarks </h6>
                </td>
                <td>: {user.remarks ? user.remarks : "N/A"}</td>
                <td width="200">
                  <h6>Deviation </h6>
                </td>
                <td>: {user.address ? "Yes" :"No"}</td>
                <td width="200">
                  <h6>Reason </h6>
                </td>
                <td>: {user.address ? user.address : "N/A"}</td>
              </tr>
              <tr>
                <td width="200">
                  <h6>Illumination </h6>
                </td>
                <td>: {user.illumination}</td>
                <td width="200">
                  <h6>Vendor Status </h6>
                </td>
                <td>
                  : {user.vendor_status}{' '}
                  {(() => {
                    const dateString = user.vendor_approval_date;
                    if (!dateString) return ''; // Return an empty string if no date is provided

                    // Normalize formats and remove time
                    const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                    // Handle DD/MM/YYYY format (no changes needed)
                    if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                      return cleanDate; // Return DD/MM/YYYY as-is
                    }

                    // Handle DD-MM-YY format (no changes needed)
                    if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                      return cleanDate; // Return DD-MM-YY as-is
                    }

                    // Handle YYYY-MM-DD format or valid ISO date
                    const formattedDate = new Date(cleanDate);
                    if (formattedDate.toString() !== 'Invalid Date') {
                      return formattedDate.toLocaleDateString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                      });
                    }

                    return ''; // Return an empty string for unrecognized formats
                  })()}
                </td>
                <td width="200">
                  <h6>Airtel Team </h6>
                </td>
                <td>
                  : {user.client_status}{' '}
                  {(() => {
                    const dateString = user.rhm_approval_date;
                    if (!dateString) return ''; // Return an empty string if no date is provided

                    // Normalize formats and remove time
                    const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                    // Handle DD/MM/YYYY format (no changes needed)
                    if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                      return cleanDate; // Return DD/MM/YYYY as-is
                    }

                    // Handle DD-MM-YY format (no changes needed)
                    if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                      return cleanDate; // Return DD-MM-YY as-is
                    }

                    // Handle YYYY-MM-DD format or valid ISO date
                    const formattedDate = new Date(cleanDate);
                    if (formattedDate.toString() !== 'Invalid Date') {
                      return formattedDate.toLocaleDateString('en-IN', {
                        timeZone: 'Asia/Kolkata',
                      });
                    }

                    return ''; // Return an empty string for unrecognized formats
                  })()}
                </td>
              </tr>
              <tr>
                <td width="200">
                  <h6>Recce Person Name </h6>
                </td>
                <td>: {user.racce_person_name}</td>

                <td width="200">
                  <h6>Recce Person Image </h6>
                </td>
                <td>
                  :{' '}
                  <button
                    type="button"
                    onClick={() =>
                      openModal(`https://amaapi.outdoorooh.com/${user.racce_person_image}`)
                    }
                    style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }} // Optional styling
                  >
                    <img
                      src={`https://amaapi.outdoorooh.com/${user.racce_person_image}`}
                      alt="Person"
                      width={60}
                      height={60}
                      onError={(e) => {
                        e.target.style.display = 'none'; // Hide the broken image
                        e.target.insertAdjacentHTML('afterend', '<span>NA</span>'); // Insert "NA" next to the image
                      }}
                    />
                  </button>
                </td>
              </tr>

              <tr>
                <td width="200" className="d-flex gap-2">
                  {user.image ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(0)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}

                  {user.image1 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(1)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image1}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}
                  {user.image2 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(2)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image2}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ' '
                  )}
                  {user.image3 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(3)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image3}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}

                  {user.image4 ? (
                    <button
                      type="button"
                      style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
                      onClick={() => handleImageClick(4)}
                    >
                      <img
                        src={`https://amaapi.outdoorooh.com/${user.image4}`}
                        alt=""
                        width={60}
                        height={60}
                      />
                    </button>
                  ) : (
                    ''
                  )}
                  <td style={{ minWidth: '230px' }}>Image Updated Date :</td>
                  <td style={{ minWidth: '230px' }}>
                    <td style={{ minWidth: '230px' }}>
                      {(() => {
                        const dateString = user.image_last_updated_date;
                        if (!dateString) return ''; // Return an empty string if no date is provided

                        // Normalize formats and remove time
                        const cleanDate = dateString.split(' ')[0]; // Extract only the date part (before space)

                        // Handle DD/MM/YYYY format (no changes needed)
                        if (/\d{2}\/\d{2}\/\d{4}/.test(cleanDate)) {
                          return cleanDate; // Return DD/MM/YYYY as-is
                        }

                        // Handle DD-MM-YY format (no changes needed)
                        if (/\d{2}-\d{2}-\d{2}/.test(cleanDate)) {
                          return cleanDate; // Return DD-MM-YY as-is
                        }

                        // Handle YYYY-MM-DD format or valid ISO date
                        const formattedDate = new Date(cleanDate);
                        if (formattedDate.toString() !== 'Invalid Date') {
                          return formattedDate.toLocaleDateString('en-IN', {
                            timeZone: 'Asia/Kolkata',
                          });
                        }

                        return ''; // Return an empty string for unrecognized formats
                      })()}
                    </td>
                  </td>
                </td>
              </tr>
            </tbody>
            <tr>
              <div className="d-flex gap-2 mt-3">
                <button
                  type="button"
                  style={{
                    background: 'blue',
                    padding: '8px 20px',
                    border: 'none',
                    color: '#fff',
                    borderRadius: '8px',
                  }}
                  onClick={() => handleApproval('Approved', 'ok')}
                >
                  Approve
                </button>
                <button
                  type="button"
                  style={{
                    background: 'red',
                    padding: '8px 20px',
                    border: 'none',
                    color: '#fff',
                    borderRadius: '8px',
                  }}
                  onClick={openRejectPopup}
                >
                  Reject
                </button>
              </div>
            </tr>
          </table>

          {isPopupOpen && (
            <div
              style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                background: '#fff',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                zIndex: 1000,
              }}
            >
              <h3>Select a reason for rejection:</h3>
              <div style={{ marginBottom: '10px' }}>
                <input
                  id="Image Blur & Not visible"
                  className="mx-2"
                  type="radio"
                  value="Image Blur & Not visible"
                  checked={selectedReason === 'Image Blur & Not visible'}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                Image Blur/Not visible
                {/* <label htmlFor="reason1">Reason 1</label> */}
              </div>
              <div style={{ marginBottom: '10px' }}>
                <input
                  id="Site Damaged & Torn"
                  className="mx-2"
                  type="radio"
                  value="Site Damaged & Torn"
                  checked={selectedReason === 'Site Damaged & Torn'}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                {/* <label htmlFor="reason2">Reason 2</label> */}
                Site Damaged/Torn
              </div>
              <div style={{ marginBottom: '10px' }}>
                <input
                  id="Incorrect Site & Missing Site"
                  type="radio"
                  className="mx-2"
                  value="Incorrect Site & Missing Site"
                  checked={selectedReason === 'Incorrect Site & Missing Site'}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                {/* <label htmlFor="reason3">Reason 3</label> */}
                Incorrect Site/Missing Site
              </div>
              <button
                type="button"
                style={{
                  background: 'green',
                  padding: '8px 20px',
                  border: 'none',
                  color: '#fff',
                  borderRadius: '8px',
                  marginRight: '10px',
                }}
                onClick={handleReject}
              >
                OK
              </button>
              <button
                type="button"
                style={{
                  background: 'gray',
                  padding: '8px 20px',
                  border: 'none',
                  color: '#fff',
                  borderRadius: '8px',
                }}
                onClick={closeRejectPopup}
              >
                Cancel
              </button>
            </div>
          )}

          {/* Background Overlay */}
          {isPopupOpen && (
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(0, 0, 0, 0.5)',
                zIndex: 999,
              }}
            ></div>
          )}

          <Modal className="custom-modal" show={showCarousel} onHide={handleCloseCarousel}>
            <Modal.Header className="header-m">
              <button type="button" className="cross" onClick={handleCloseCarousel}>
                x
              </button>
            </Modal.Header>
            <Modal.Body>
              <Carousel
                activeIndex={currentImageIndex}
                onSelect={(selectedIndex) => setCurrentImageIndex(selectedIndex)}
              >
                {[user.image, user.image1, user.image2, user.image3, user.image4].map((img) => (
                  <Carousel.Item key={img}>
                    <img className="" src={`https://amaapi.outdoorooh.com/${img}`} alt="Slide" />
                  </Carousel.Item>
                ))}
              </Carousel>
            </Modal.Body>
          </Modal>

          {isModalOpen && (
            <div style={modalStyles.overlay}>
              <div style={modalStyles.modal}>
                <button
                  onClick={closeModal}
                  type="button"
                  className="primary mb-2"
                  style={modalStyles.closeButton}
                >
                  x
                </button>
                <img src={selectedImage} alt="Preview" style={modalStyles.image} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GujraatStateHeadPending;
